export const learnTagsSortedByPriority = {
  BANKRUPTCY_BASICS: "bankruptcyBasics",
  CHAPTER_7: "chapter7",
  BANKRUPTCY_BY_STATE: "bankruptcyByState",
  PROPERTY_EXEMPTIONS: "propertyExemptions",
  DEBTS: "debts",
  WAGE_GARNISHMENT: "wageGarnishment",
  CARS: "cars",
  STUDENT_LOANS: "studentLoans",
  UPSOLVE: "upsolve",
  CONSUMER_RIGHTS: "consumerRights",
  TAXES: "taxes",
  CHAPTER_13: "chapter13",
  COURT: "court",
  DIVORCE: "divorce",
  CHAPTER_11: "chapter11",
  NEWS: "news",
};
